import firebase from 'firebase';
import { firebaseAuth } from '@/firebase';
import { Config } from '@/config';
import { AuthRawModel } from '@/api/api-raw-models/user-raw-model';
import { AuthModel } from '@/models/UserModel';
import { mapAuth } from '@/api/mappers/map-response';
import BaseAuthApiService from '@/api/base-auth-api-service';

export class UserApiService extends BaseAuthApiService {
  private readonly userPrefix = 'users';

  /**
   * Sign in anonymous user
   * @return {Promise<AuthModel>}
   */
  public async guestSignIn(): Promise<AuthModel> {
    // sign in anonymously using firebase
    const firebaseUserCredential: firebase.auth.UserCredential = await firebaseAuth.signInAnonymously();

    const body = {
      fb_id: firebaseUserCredential.user?.uid, // eslint-disable-line @typescript-eslint/camelcase
      is_guest_account: true, // eslint-disable-line @typescript-eslint/camelcase
    };

    const url = `${Config.ApiUrl}/${this.userPrefix}/login`;

    const res = await fetch(url, {
      method: 'POST',
      headers: this.headers,
      body: JSON.stringify(body),
    });

    const authModel: AuthModel = await this.mapResponse<AuthRawModel, AuthModel>(res, mapAuth);
    this.authService.setAuth(authModel);

    return authModel;
  }
}
